<template>
	<div class="my" id="app">
		<router-view />

  </div>
</template>



<script>
import DevicePixelRatio from './lib/devicePixelRatio.js';
export default {
  name: "app",
  created() {
	new DevicePixelRatio().init();

  },
	data(){
		// eslint-disable-next-line no-mixed-spaces-and-tabs
  	return{
			// eslint-disable-next-line no-mixed-spaces-and-tabs


		}
	}

};
</script>

<style>
	div::-webkit-scrollbar{
		width:10px;
		height:10px;
		/**/
	}
	div::-webkit-scrollbar-track{
		background: rgb(239, 239, 239);
		border-radius:2px;
	}
	div::-webkit-scrollbar-thumb{
		background: #bfbfbf;
		border-radius:10px;
	}
	div::-webkit-scrollbar-thumb:hover{
		background: #333;
	}
	div::-webkit-scrollbar-corner{
		background: #179a16;
	}
#app {
	padding: 0;
	width: 100%;
	height: 100%;
	margin: 0;

	/*background-color: #FAFAFA;*/
}


	.el-loading-spinner .path{
		animation: loading-dash 1.5s ease-in-out infinite;
		stroke-dasharray: 90,150;
		stroke-dashoffset: 0;
		stroke-width: 4;
		stroke: #FF7BAC;
		stroke-linecap: round;
	}

.el-loading-spinner .el-loading-text {
	color: #FF7BAC;
	margin: 3px 0;
	font-size: 14px;
}

a{
	text-decoration:none;
	color: inherit;
}
html{
	height: 100%;
}
#nav{
	height: 100%;
}
body{
	height: 100%;
	margin: 0;
	padding: 0;
}
.image-swiper-pagination{
	margin-top: 52px;
	height: 4px;
	display: flex;
	justify-content: center;
	background-color: white;
}
.image-swiper-pagination-bullet{
	display: inline-block;
	width:27px;
	height:4px;
	margin-right: 7px;
	background:rgba(0,0,0,0.1);
	cursor: pointer;
}
.active-image-swiper-pagination-bullet{
	width:28px;
	height:4px;
	background:rgba(0,0,0,0.4);
}
</style>
